import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  FDAccordion, FDAccordionDetails,
  FDAccordionGroup, FDAccordionTitle, FDBodyText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('FrequentlyAskedQuestions', (theme) => ({
  rootEmphasis: {
    '& svg.FD-MuiSvgIcon-root': {
      fill: theme.palette.facet.orange,
    },
  },
}));

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['question', 'answer'], {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .override({ name: 'question', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly)
  .override({ name: 'answer', hint: 'richtext' }, {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly);

export const FrequentlyAskedQuestionsAccordion = ({ faqResource, isOnEmphasisBackground }) => {
  const classes = useStyles();

  if (!faqResource) {
    return null;
  }

  return (
    <div className={classNames({
      [classes.rootEmphasis]: isOnEmphasisBackground,
    })}
    >
      <FDAccordionGroup mutualExclusion>
        {faqResource.attr('questions').resources().list().map((questionResource) => {
          return (
            <FDAccordion
              expansionID={questionResource.id()}
              key={questionResource.id()}
            >
              <FDAccordionTitle>
                <MetaControl resource={questionResource} attrName={'question'} metaOverrideSet={metaOverrideSet} />
              </FDAccordionTitle>
              <FDAccordionDetails>
                <MetaControl resource={questionResource} attrName={'answer'} metaOverrideSet={metaOverrideSet} />
              </FDAccordionDetails>
            </FDAccordion>
          );
        })}
      </FDAccordionGroup>
    </div>
  );
};

FrequentlyAskedQuestionsAccordion.defaultProps = {
  isOnEmphasisBackground: false,
};

FrequentlyAskedQuestionsAccordion.propTypes = {
  faqResource: PropTypes.object.isRequired,
  isOnEmphasisBackground: PropTypes.bool,
};
